import { ContentChildren, ElementRef, Directive } from '@angular/core';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';

const GRID_TOOLBAR_TOGGLE_BUTTON_GROUP_CLASSES = {
  hidden: 'xpo-gridToolbar-button--hidden',
};
@Directive({
  selector: 'xpo-grid-toolbar-toggle-buttons-group',
  host: {
    'data-cy': 'action-buttons-group-more',
  },
})
export class XpoGridToolbarToggleButtonsGroup {
  constructor(public el: ElementRef<HTMLElement>) {}

  @ContentChildren(MatButtonToggleGroup) buttons: any;
  buttonsAreHiding: boolean = false;

  hideButtons(): void {
    const firstChild = this.el?.nativeElement?.children[0];
    if (!firstChild.children) {
      return;
    }
    let totalChildrenWidth = 0;

    // HTMLCollection must be iterated using for statements
    for (let index = 0; index < firstChild.children.length; index++) {
      const element = firstChild.children[index];
      totalChildrenWidth = totalChildrenWidth + element.clientWidth;
    }

    if (totalChildrenWidth > firstChild.clientWidth) {
      this.el.nativeElement.classList.add(GRID_TOOLBAR_TOGGLE_BUTTON_GROUP_CLASSES.hidden);
      this.buttonsAreHiding = true;
    }
  }

  showButtons(): void {
    this.el.nativeElement.classList.remove(GRID_TOOLBAR_TOGGLE_BUTTON_GROUP_CLASSES.hidden);
    this.buttonsAreHiding = false;
  }
}
